import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
		userInfo: {
			custId: '',
			mobile: '',
			nickName: '',
			headImgUrl: '',
			sessionLastUseDevId: '',
			totalBean: 0,
		},
		token: '',
		uploadInfo: {
			uploadToken: '',
			uploadUrl: '',
		},
		uploadPro: [],
		uploadPopShow: false,
		uploadSucList: [],
		uploadErrorList:[],
		uploadErrorShow: false,
		uploadFlag: false,
  },
  mutations: {
		setRequestHeader(state, param) {
			state.token = param
		},
		setUploadInfo(state, param) {
			state.uploadInfo = param;
		},
		clearUploadPro(state) {
			state.uploadPro = []
		},
		changeUploadPopShow(state, param) {
			state.uploadPopShow = param
		},
		updateUploadProByIndex(state, param) {
			state.uploadPro.splice(param.index, 1, param)
		},
		setUploadSucList(state, param) {
			state.uploadSucList = param;
		},
		setUploadErrorList(state, param) {
			state.uploadErrorList = param;
		},
		setUploadErrorShow(state, param) {
			state.uploadErrorShow = param;
		},
		changeUploadPopShow(state, param) {
			state.uploadPopShow = param
		},
		addUploadPro(state, param) {
			state.uploadPro.push(param)
		},
		setUserInfo(state, param) {
			state.userInfo = { ...state.userInfo,
				...param
			}
		},
		setUploadFlag(state, param) {
			state.uploadFlag = param;
		},
  },
  actions: {
  },
  modules: {
  }
})
